export default {
    // api: 'https://api.martendenheijer.nl/data-service/v4'
    api: 'https://data-service-v4.herokuapp.com'
}



// WEBPACK FOOTER //
// ./src/config/index.js